<template>
  <div :class="$style.wraper">
    <div :class="$style.zoom" v-bind="$attrs">
      <div class="cursor-pointer" :class="$style.zoom__item" @click="onPlus">
        <i :class="$style.zoom__item__icon" class="el-icon-plus" />
      </div>
      <div class="cursor-pointer" :class="$style.zoom__item" @click="onMinus">
        <i :class="$style.zoom__item__icon" class="el-icon-minus" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@nuxtjs/composition-api";

import { useL7Scene } from "./useL7Scene";

export default defineComponent({
  name: "L7Zoom",
  setup(props) {
    const { scene } = useL7Scene();
    const onPlus = () => {
      scene.value.zoomIn();
    };
    const onMinus = () => {
      scene.value.zoomOut();
    };
    return {
      onPlus,
      onMinus,
    };
  },
});
</script>

<style lang="scss" module>
.wraper {
  position: fixed;
  right: 0.75rem;
  bottom: 1.25rem;
  z-index: 100;
}
.zoom > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.zoom {
  border-radius: 0.5rem;
  --tw-shadow:  0px 4px 10px 0px rgba(0,0,0,0.1);
  --tw-shadow-colored:  0px 4px 10px 0px var(--tw-shadow-color);
  -webkit-box-shadow: var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow);
}
.zoom__item {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  height: 3rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 3rem;
  -webkit-transition-property: background-color, border-color, color, fill, stroke;
  -o-transition-property: background-color, border-color, color, fill, stroke;
  transition-property: background-color, border-color, color, fill, stroke;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
}
.zoom__item:active {
  --tw-bg-opacity: 1;
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}
.zoom__item:first-child {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.zoom__item:last-child {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.zoom__item__icon {
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}
</style>
